import api from "@/api";
import {
  Exception,
  PageModel,
  PaginationModel,
  WalletModel,
  WalletUpdateRequest,
} from "../types";

export default class WalletApi {
  static async list(memberId: string): Promise<PageModel<WalletModel>> {
    return await api.get(`wallet/${memberId}`);
  }

  static async single(walletId: string): Promise<WalletModel> {
    return await api.get(`wallet/single/${walletId}`);
  }

  static async release(memberId: string, data: WalletUpdateRequest) {
    return await api.put(`lockup/release/${memberId}`, data);
  }

  static async update(walletId: string, data: WalletUpdateRequest) {
    return await api.put(`lockup/${walletId}`, data);
  }

  static async info(){
    return await api.get(`admin/walletinfo`);
  }
}
